import { Button, IconButton, Table, TableCell, TableContainer, TableRow } from "@mui/material";
import styled from "styled-components";
import { AddressableGroupMode, IOrganization, IWorkspaceAddressableParam, ProductType } from "./AddressableSetup.types";
import { maskCNPJ } from "./AddressableSetup.utils";
import CreateGroup from "components/svg/create-group";
import { useState } from "react";
import { AddressableSetupCreate } from "./AddressableSetup.Create";
import { ArrowBack, DeleteOutline } from "@mui/icons-material";
import api from "services/api";

interface IProps {
  data: IOrganization;
  handleRemoveOrganization: () => void;
  refetchOrganizations: () => Promise<any>;
  updateSelectedOrganization: (organizationId: string, updatedData?: IOrganization[]) => void;
}

const Title = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: #191c1a;
`;

export const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #191c1a;
`;

export const PageSubtitle = styled.span`
  font-size: 16px;
  font-weight: 400;
  color: #0F0F1E99;
`;

const productTypeLabels: Record<ProductType, string> = {
  HEALTH: "Grupo de Saúde",
  DENTAL: "Grupo de Dental",
  LIFE: "Grupo de Vida",
};

export function AddressableSetupListWorkspaces({ data, handleRemoveOrganization, refetchOrganizations, updateSelectedOrganization }: IProps) {
  const [addressableGroup, setAddressableGroup] = useState<IWorkspaceAddressableParam | null>(null);
  const [mode, setMode] = useState<AddressableGroupMode>("create");

  function handleCreateGroup() {
    setMode("create");
    setAddressableGroup({
      id: `${Math.random()}`,
      workspaces: []
    });
  }

  function handleEditGroup(param: IWorkspaceAddressableParam) {
    setMode("edit");
    setAddressableGroup(param);
  }

  function handleRemoveGroup() {
    setAddressableGroup(null);
  }

  async function handleDeleteGroup(e: React.MouseEvent, groupId: string) {
    e.stopPropagation();
    if (!window.confirm("Tem certeza que deseja remover este grupo?")) return;

    try {
      await api.delete(`/v2/addressable/groups/${groupId}`);
      const result = await refetchOrganizations();
      updateSelectedOrganization(data.id, result.data as IOrganization[]);
    } catch (err) {
      console.error(err);
      alert("Erro ao remover grupo.");
    }
  }

  return (
    <>
      {!!addressableGroup ? (
        <AddressableSetupCreate
          addressableGroup={addressableGroup}
          organization={data}
          handleRemoveGroup={handleRemoveGroup}
          refetchOrganizations={refetchOrganizations}
          updateSelectedOrganization={updateSelectedOrganization}
          mode={mode}
        />
      ) : (
        <>
          <div style={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={handleRemoveOrganization}
            >
              <ArrowBack color="primary" />
            </IconButton>
            <PageTitle>Endereçabilidade</PageTitle>
          </div>
          <div style={{ width: "100%", display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
            <div style={{ width: '70%', border: 'solid 1px #E8E8E8', borderRadius: '16px', padding: '16px', display: 'flex', flexDirection: 'row', justifyContent: "space-between", marginBottom: "20px" }}>
              <div style={{ display: 'flex', flexDirection: "column", width: "300px" }}>
                <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78', margin: "0", padding: "0" }}>Cliente</p>
                <span style={{ fontSize: '16px', lineHeight: "150%", fontWeight: '600', color: '#6F6F78', margin: "0", padding: "0" }}>{data.corporateName}</span>
              </div>
              <div style={{ display: 'flex', flexDirection: "column", width: "300px" }}>
                <p style={{ fontSize: '12px', lineHeight: '20px', color: '#6F6F78', margin: "0", padding: "0" }}>CNPJ</p>
                <span style={{ fontSize: '16px', lineHeight: "150%", fontWeight: '600', color: '#6F6F78', margin: "0", padding: "0" }}>{maskCNPJ(data.federalTaxId)}</span>
              </div>
            </div>
            {!!data.workspaceAddressableParams.length && (
              <Button
                variant='contained'
                style={{"width":"150px","paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                onClick={handleCreateGroup}
              >
                + Novo grupo
              </Button>
            )}
          </div>
          {!data.workspaceAddressableParams.length ? (
            <div style={{ width: "100%", height: "500px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px", marginTop: "30px", marginBottom: "50px" }}>
              <CreateGroup />
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <p style={{ fontSize: '16px', color: '#6F6F78', margin: "0", padding: "0" }}>Use o botão abaixo para criar um grupo de endereçabilidade</p>
              </div>
              <Button
                variant='text'
                style={{"width":"150px","paddingTop":"0.25rem","paddingBottom":"0.25rem","paddingLeft":"1rem","paddingRight":"1rem","borderRadius":"0.375rem","height":"2.5rem","fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":600}}
                onClick={handleCreateGroup}
              >
                + Novo grupo
              </Button>
            </div>
          ) : (
            <TableContainer sx={{ "& .MuiTableCell-root": { background: "#FFFFFF !important" } }}>
              <Table>
                <TableRow style={{ height: '70px'}}>
                  <TableCell style={{ width: "500px"}}>
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                      Grupo
                    </span>
                  </TableCell>
                  <TableCell style={{ width: "60%"}}>
                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: 'rgb(111, 111, 120)', fontWeight: '600' }}>
                      Workspaces
                    </span>
                  </TableCell>
                  <TableCell style={{ width: "60px"}} />
                </TableRow>
                {data.workspaceAddressableParams.map((param, i) => (
                  <TableRow key={param.id + i} style={{ height: '70px', cursor: "pointer" }} onClick={() => handleEditGroup(param)}>
                    <TableCell>
                      <Title>
                        {param.workspaces.length > 0
                          ? productTypeLabels[param.workspaces[0].product.productType]
                          : "-"}
                      </Title>
                    </TableCell>
                    <TableCell>{param.workspaces.length}</TableCell>
                    <TableCell align="center">
                      <IconButton size="small" onClick={(e) => handleDeleteGroup(e, param.id)}>
                        <DeleteOutline color="error" fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </Table>
            </TableContainer>
          )}
        </>
      )}
    </>  
  );
}
